import { DateTime, Interval } from "luxon";
import { DateDiff } from "~/helpers/dates.server";

export function formatLongDate(date: Date, locale: string): string {
  return date.toLocaleDateString(locale, {
    year: "numeric",
    month: "long",
    day: "numeric"
  })
    // For Russian - remove " г." from the end of the string
    .replace(" г.", "");
}


/**
 * Returns the difference between two dates split to years, months, days, hours, minutes, seconds
 * as well as total days, hours, minutes and months.
 * @param date1
 * @param date2
 */
export function getDatesDiff(date1: Date, date2: Date): DateDiff {
  if (date2 < date1) {
    [date1, date2] = [date2, date1];
  }

  const luxonDate1 = DateTime.fromJSDate(date1);
  const luxonDate2 = DateTime.fromJSDate(date2);

  const interval = Interval.fromDateTimes(luxonDate1, luxonDate2);
  const duration = interval.toDuration(['years', 'months', 'days', 'hours', 'minutes', 'seconds']);

  return {
    years: Math.floor(duration.years),
    months: Math.floor(duration.months),
    days: Math.floor(duration.days),
    hours: Math.floor(duration.hours),
    minutes: Math.floor(duration.minutes),
    seconds: Math.floor(duration.seconds),
    totalYears: Math.floor(luxonDate2.diff(luxonDate1, 'years').years),
    totalMonths: Math.floor(luxonDate2.diff(luxonDate1, 'months').months),
    totalDays: Math.floor(luxonDate2.diff(luxonDate1, 'days').days),
    totalHours: Math.floor(luxonDate2.diff(luxonDate1, 'hours').hours),
    totalMinutes: Math.floor(luxonDate2.diff(luxonDate1, 'minutes').minutes),
  };
}

/**
 * Creates a hydration-safe version of a DateDiff object by zeroing out time-dependent values
 * that might cause hydration mismatches between server and client due to timezone differences.
 * 
 * @param diff Original DateDiff object
 * @returns DateDiff with hours, minutes, and seconds set to zero
 */
export function createHydrationSafeDiff(diff: DateDiff): DateDiff {
  return {
    ...diff,
    hours: 0,
    minutes: 0,
    seconds: 0
  };
}
